import { formatTime } from "@clipboard-health/date-time";

import { ShiftBottomSheetBookabilityCriteriaCard } from "../BottomSheet/BookabilityCriteriaCard";

interface OrientationCardProps {
  adjustedStart: Date;
  orientationLengthInMinutes: number;
  timeZone?: string;
}

export function PreShiftOrientationCard(props: OrientationCardProps) {
  const { adjustedStart, orientationLengthInMinutes, timeZone } = props;

  const formattedTime = formatTime(adjustedStart, { timeZone });
  const description =
    orientationLengthInMinutes === 0
      ? "An orientation is part of your first shift. Arrive on time to hit the ground running."
      : `A ${orientationLengthInMinutes} minute orientation is part of your first shift. Arrive on time to hit the ground running.`;

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="success"
      illustrationType="document-approved"
      title={`Arrive at ${formattedTime} for an orientation`}
      description={description}
    />
  );
}
